import { FetchError } from "utils/errors";

type VerifyPylonUserResponse = {
  jwt: string;
  account_external_id: string;
  contact_external_id: string;
};

const usePylonAuthentication = () => {
  const verifyPylonUser = async (): Promise<VerifyPylonUserResponse> => {
    const response = await fetch("/pylon/verification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({}),
    });

    if (!response) {
      throw new Error("Failed to verify");
    }

    if (!response.ok) {
      throw new FetchError(response.status);
    }

    const responseJson = await response.json();

    return {
      jwt: responseJson.jwt,
      account_external_id: responseJson.account_external_id,
      contact_external_id: responseJson.contact_external_id,
    };
  };

  return {
    verifyPylonUser,
  };
};

export default usePylonAuthentication;
